<template>
  <div class="consult-card" v-if="CommonIncomingData">
    <div class="c-title">营养审核专家</div>
    <div class="c-center" @click="jumpToStarPage">
      <img
        class="c-avatar"
        :src="CommonIncomingData.head_portrait"
        alt=""
        v-buried
        data-buried="BG_PTSW_YYSZY"
        v-clickBuried
        data-click-buried="CLICK_PTSW_YYSZY"
      />
      <div class="c-c-right">
        <div class="c-nickname">{{ CommonIncomingData.name }}</div>
        <div class="c-desc">{{ CommonIncomingData.title }}</div>
      </div>
    </div>
    <!--  <div class="c-btn" v-clickBuried data-click-buried="CLICK_PTSW_ZX" @click="jumpIncoming">获取针对性饮食建议<span class="iconfont icon-you"></span></div> -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      CommonIncomingData: null
    }
  },
  created() {
    this.getCommonIncomingUrl()
  },
  methods: {
    async getCommonIncomingUrl() {
      let res = await this.$http
        .getBaseApp('api/v3/expert/getCommonIncomingUrl', { source_type: 4 })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.CommonIncomingData = res.data
        }
      }
    },
    jumpToStarPage() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.router)
    },
    jumpIncoming() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.incoming_url)
    }
  }
}
</script>
<style lang="scss" scoped>
.consult-card {
  box-sizing: border-box;
  margin: 0 auto;
  width: 343px;
  color: rgba(0, 0, 0, 0.8);
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 16px;
  padding: 14px 16px;

  .c-title {
    font-weight: bold;
    font-size: 15px;
    line-height: 21px;
    margin-bottom: 18px;
  }

  .c-center {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .c-avatar {
      width: 43px;
      height: 43px;
      overflow: hidden;
      border-radius: 8px;
      object-fit: cover;
      margin-right: 12px;
    }

    .c-c-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .c-nickname {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
      }

      .c-desc {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.7);
        font-weight: bold;
        font-size: 10px;
      }
    }
  }

  .c-btn {
    height: 35px;
    background: linear-gradient(149deg, #9071ff 0%, #7d9afc 100%);
    border-radius: 18px;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
